import { render, staticRenderFns } from "./RequestEdit.vue?vue&type=template&id=56ab02d8&scoped=true&"
import script from "./RequestEdit.vue?vue&type=script&lang=js&"
export * from "./RequestEdit.vue?vue&type=script&lang=js&"
import style0 from "./RequestEdit.vue?vue&type=style&index=0&id=56ab02d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ab02d8",
  null
  
)

export default component.exports